import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {  Router,NavigationEnd } from '@angular/router';
import { SharedDataService } from './shared/services/shared-data.service';
import { UserManagementService } from './user-management/shared/services/user-management.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit{
  title = 'app';

  constructor(private router : Router, private _location : Location, private userMgmtSvc : UserManagementService){
    
  }

  ngOnInit(){

}

}
